// extracted by mini-css-extract-plugin
export default {"button":"VacanciesPage_button__-g+yQ"};